module.exports = __webpack_public_path__ + "static/media/logo.0f7ddd95.png";